'use client'
import {ButtonColor, textColorMap} from "@web-libs/ui/ui-components/buttons/button";
import {getCssVar} from "@web-libs/features/colors/application/colors";
import {SvgFunction} from "@web-libs/ui/svgs/types";
import css from "./button.module.css";
import {CSSProperties} from "react";

export type RoundButtonProps = {
    color: ButtonColor,
    onClick?: () => void,
    svg: SvgFunction,
    size?: number,
    style?: CSSProperties,
    svgSize?: number,
    disabled?: boolean,
    text?: string
}

export const RoundButton = ({color = "primary", onClick, svg, style:_style, size = 50,svgSize, disabled, text}: RoundButtonProps) => {
    const buttonColor = disabled ? getCssVar("unobtrusive"): getCssVar(color);
    const textColor = getCssVar(textColorMap[color] ?? "light");

    const style: CSSProperties = {
        backgroundColor: buttonColor,
        color: textColor,
        width: size,
        height: size,
        borderRadius: size / 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        fontWeight: "bold",
        padding: 4,
        cursor: disabled ? "not-allowed" : "pointer",
        ..._style
    }

    const iconSize = svgSize ?? size * 0.5;

    const _onClick = disabled ? () => {} : onClick

    return (
        <button className={disabled ? undefined: css.roundButton} onClick={_onClick} style={style}>
            {svg({fill: textColor, width: iconSize, height: iconSize})}
            {text && <span>{text}</span>}
        </button>
    )
}

